import { each } from "fxjs/es";
export const abortCopy = (self) => {
  if (self._copy_source_grid_id == null) {
    throw new Error(`먼저 복사를 시작해주세요.`);
  }
  const empty_grid_layer_el = self._getEmptyGridLayerElThrowable();
  const copy_source_grid_layer_el = self._getCopySourceGridLayerElThrowable();
  const copy_destination_unselected_empty_grid_layer_el =
    self._getCopyDestinationUnselectedEmptyGridLayerElThrowable();
  const copy_destination_unselected_existing_grid_layer_el =
    self._getCopyDestinationUnselectedExistingGridLayerElThrowable();
  const copy_destination_selected_grid_layer_el =
    self._getCopyDestinationSelectedGridLayerElThrowable();
  each(
    ({
      target_image_el,
      empty_grid_el,
      copy_source_grid_el,
      copy_destination_unselected_empty_grid_el,
      copy_destination_unselected_existing_grid_el,
      copy_destination_selected_grid_el,
    }) => {
      if (copy_source_grid_layer_el.contains(copy_source_grid_el)) {
        copy_source_grid_layer_el.removeChild(copy_source_grid_el);
      }
      if (
        copy_destination_unselected_empty_grid_layer_el.contains(
          copy_destination_unselected_empty_grid_el
        )
      ) {
        copy_destination_unselected_empty_grid_layer_el.removeChild(
          copy_destination_unselected_empty_grid_el
        );
      }
      if (
        copy_destination_unselected_existing_grid_layer_el.contains(
          copy_destination_unselected_existing_grid_el
        )
      ) {
        copy_destination_unselected_existing_grid_layer_el.removeChild(
          copy_destination_unselected_existing_grid_el
        );
      }
      if (
        copy_destination_selected_grid_layer_el.contains(
          copy_destination_selected_grid_el
        )
      ) {
        copy_destination_selected_grid_layer_el.removeChild(
          copy_destination_selected_grid_el
        );
      }
      if (target_image_el == null) {
        empty_grid_layer_el.appendChild(empty_grid_el);
      }
    }
  )(self._grids.values());
  self._copy_source_grid_id = null;
};
